var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 -4.54747351e-13 12 -4.54747351e-13 12 20 0 20"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Appointment-Form-6",
    transform: "translate(-507.000000, -1642.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(507.686292, 1638.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(11.313708, 16.000000) rotate(-45.000000) translate(-11.313708, -16.000000) translate(5.313708, 6.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.54985993,-4.54747351e-13 C5.09602432,-4.54747351e-13 3.09948143,2.07568452 3.09948143,4.62709322 L3.09948143,7.68496598 L3.09948143,12.5629362 L3.09948143,12.8938855 C3.09948143,14.4881441 4.34714192,15.7856638 5.88090839,15.7856638 C7.41443643,15.7856638 8.66209692,14.4881441 8.66209692,12.8938855 L8.66209692,4.95804256 C8.66209692,4.54726874 8.34189664,4.21433618 7.94683197,4.21433618 C7.5517673,4.21433618 7.23156703,4.54726874 7.23156703,4.95804256 L7.23156703,12.8938855 C7.23156703,13.6683317 6.62573762,14.2982511 5.88090839,14.2982511 C5.13607916,14.2982511 4.53001133,13.6683317 4.53001133,12.8938855 L4.53001133,12.5629362 L4.53001133,7.68496598 L4.53001133,4.62709322 C4.53001133,2.89599266 5.88472313,1.48741277 7.54985993,1.48741277 C9.2147583,1.48741277 10.5694701,2.89599266 10.5694701,4.62709322 L10.5694701,7.43706385 L10.5694701,12.5629362 L10.5694701,13.7615429 C10.5694701,16.3811247 8.51975919,18.5125872 6.00011921,18.5125872 C3.48047923,18.5125872 1.43052989,16.3811247 1.43052989,13.7615429 L1.43052989,5.20594469 C1.43052989,4.79517087 1.11032962,4.46223831 0.715264946,4.46223831 C0.320438696,4.46223831 0,4.79517087 0,5.20594469 L0,13.7615429 C0,17.2014329 2.69178041,20 6.00011921,20 C9.30845801,20 12,17.2014329 12,13.7615429 L12,12.5629362 L12,7.43706385 L12,4.62709322 C12,2.07568452 10.0036955,-4.54747351e-13 7.54985993,-4.54747351e-13",
    id: "Fill-1",
    fill: "#516983",
    mask: "url(#mask-2)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAttachment);
export default __webpack_public_path__ + "static/media/icon_attachment.6f6361e6d7f6c640b60e7c98928c9c80.svg";
export { ForwardRef as ReactComponent };